'use client'

// import { useRouter } from '@/i18n/navigation'
// import { useEffect } from 'react'
// import { ROUTES } from '../constants/routes'
// import { useAuth } from '../store/auth'

type Props = {
  children: React.ReactNode
}

export const CustomerGuard: React.FC<Props> = ({ children }) => {
  // const { isAuthenticated, status } = useAuth()
  // const router = useRouter()

  // useEffect(() => {
  //   if (status === 'pending') return

  //   if (!isAuthenticated) {
  //     return router.replace(ROUTES.home)
  //   }
  // }, [isAuthenticated, router, status])

  return children
}
